export default __webpack_public_path__ + "static/media/cloud_service.ef0cab93.png";